import { useCallback, useMemo } from "react";
import { useRouteTabSelection } from "../../../components/navigationTabs/useRouteTabSelection";
import { ORDERS } from "../../../constants/routes";

export const useOrderListTabSelection = ({
  attentionTabName,
  defaultTab,
  enabled,
}: {
  attentionTabName: string;
  defaultTab: string;
  enabled: boolean;
}) => {
  const tabs = useMemo(
    () => [attentionTabName, "All orders"],
    [attentionTabName],
  );
  const resolvePathname = useCallback(() => ORDERS, []);

  return useRouteTabSelection({
    defaultTab,
    enabled,
    resolvePathname,
    route: ORDERS,
    tabs,
  });
};
